import { Checkbox, IconButton } from "@radix-ui/themes";
import { TrashIcon } from "@radix-ui/react-icons";
import { TableBody, TableCell, TableRow } from "@/v2/shared/shadcn-ui/table";
import { EditableTableField, EditableTableRow } from "./EditableTable.model";
import { EditableTableFieldRender } from "./EditableTableFieldRender";

export interface EditableTableBodyProps {
  rows: EditableTableRow[];
  fields: EditableTableField[];
  showToggle?: boolean;
  updateRow: (id: string, updates: Partial<EditableTableRow>) => void;
  deleteRow: (id: string) => void;
  toggleRow: (id: string) => void;
  getDuplicateInfo?: () => {
    duplicateKeys: Set<string>;
    strikeOutRows: Set<string>;
  };
}

export function EditableTableBody({
  rows,
  fields,
  showToggle = true,
  updateRow,
  deleteRow,
  toggleRow,
  getDuplicateInfo,
}: EditableTableBodyProps) {
  return (
    <TableBody>
      {rows.map((row) => {
        const duplicateInfo = getDuplicateInfo?.();
        const isStrikeOutRow =
          duplicateInfo?.strikeOutRows.has(row.id) || false;

        return (
          <TableRow
            key={row.id}
            className={!row.enabled ? "opacity-50 h-[32px]" : "h-[32px]"}
          >
            {showToggle && (
              <TableCell className="p-0 py-0">
                <div className="w-full h-full flex items-center justify-center">
                  <Checkbox
                    size="2"
                    variant="soft"
                    checked={row.enabled}
                    onClick={() => toggleRow(row.id)}
                  />
                </div>
              </TableCell>
            )}
            {fields.map((field) => {
              const keyValue = row[field.key];
              const isDuplicate =
                duplicateInfo &&
                keyValue &&
                keyValue.toString().trim() !== "" &&
                duplicateInfo.duplicateKeys.has(`${field.key}:${keyValue}`);
              const shouldStrikeOut = isStrikeOutRow && isDuplicate;

              return (
                <TableCell key={field.key} className="p-0 py-0">
                  <div className="w-full">
                    <EditableTableFieldRender
                      field={field}
                      row={row}
                      updateRow={updateRow}
                      shouldStrikeOut={shouldStrikeOut}
                    />
                  </div>
                </TableCell>
              );
            })}
            <TableCell className="p-0 py-0">
              <IconButton
                size="2"
                color="red"
                variant="soft"
                onClick={() => deleteRow(row.id)}
              >
                <TrashIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
}
